import React from 'react';

import styles from './page-container.module.scss';

export interface PageContainerProps {
  children: React.ReactNode;
}

/**
 * <PageContainer> standardizes the spacing above and below page content.
 * It's generally used with `<CenteredContainer>` to build a page's
 * high-level layout.
 *
 * This component is intended to REPLACE the `PageContainer` from Currency,
 * which has much larger values for marginTop.
 */
const PageContainer = ({ children }: PageContainerProps): React.ReactNode => (
  <div className={styles.container}>{children}</div>
);

export default PageContainer;
